export const HIDE_SIDEBAR_SX = {
  'msOverflowStyle': 'none', // IE 10+
  'scrollbarWidth': 'none', // Firefox
  '&::-webkit-scrollbar': {
    display: 'none', // Safari and Chrome
  },
}
